import { findIndex, cloneDeep } from 'lodash-es'

export const types = {
  CLEAR_STATE: 'CLEAR_STATE',
  INITIAL_STATE: 'INITIAL_STATE',
  HANDLE_INPUT_CHANGE: 'HANDLE_INPUT_CHANGE',
  HANDLE_INPUT_CLEAR: 'HANDLE_INPUT_CLEAR',
  HANDLE_CONTROL_CLICK: 'HANDLE_CONTROL_CLICK',
  HANDLE_OPTION_SINGLE_SELECT: 'HANDLE_OPTION_SINGLE_SELECT',
  HANDLE_OPTION_MULTI_SELECT: 'HANDLE_OPTION_MULTI_SELECT',
  HANDLE_ALL_CLICK: 'HANDLE_ALL_CLICK',
  HANDLE_MULTI_REMOVE: 'HANDLE_MULTI_REMOVE',
}

export const initialState = {
  isMenuOpened: false,
  inputValue: '',
  options: [],
  currentOptions: [],
  selectedOption: [],
  currentAction: '',
}

const ACTION = {
  MULTI_REMOVE: 'multi-remove',
  INPUT_CLEAR: 'input-clear',
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR_STATE':
      return initialState
    case 'INITIAL_STATE':
      return handleInitial(state, action)
    case 'HANDLE_INPUT_CHANGE':
      return handleInputChange(state, action)
    case 'HANDLE_INPUT_CLEAR':
      return handleInputClear(state, action)
    case 'HANDLE_CONTROL_CLICK':
      return handleControlClick(state, action)
    case 'HANDLE_OPTION_SINGLE_SELECT':
      return handleOptionSingleSelect(state, action)
    case 'HANDLE_OPTION_MULTI_SELECT':
      return handleOptionMultiSelect(state, action)
    case 'HANDLE_ALL_CLICK':
      return handleAllClear(state, action)
    case 'HANDLE_MULTI_REMOVE':
      return handleMultiRemove(state, action)
    default:
      throw new Error()
  }
}

function handleInitial(state, action) {
  return {
    ...state,
    options: action.options,
    currentOptions: action.options,
    selectedOption: action.selectedOption,
    currentAction: '',
  }
}

function handleInputChange(state, action) {
  const filterOptions = state.options
    .filter((item) => item.label?.toLowerCase().includes(action.value.toLowerCase()))
    .filter((item) => findIndex(state.selectedOption, { label: item.label }) === -1)

  return {
    ...state,
    isMenuOpened: true,
    inputValue: action.value,
    currentOptions: filterOptions,
    currentAction: '',
  }
}

function handleInputClear(state) {
  const newCurrentOptions = state.options.filter((item) => findIndex(state.selectedOption, { label: item.label }) === -1)

  return {
    ...state,
    isMenuOpened: state.currentAction === ACTION.MULTI_REMOVE, // 如果是 multi-remove 就不把 menu 關掉
    inputValue: '',
    currentOptions: newCurrentOptions,
    currentAction: ACTION.INPUT_CLEAR,
  }
}

function handleControlClick(state) {
  return {
    ...state,
    isMenuOpened: !state.isMenuOpened,
    inputValue: '',
    currentOptions: state.options,
    currentAction: '',
  }
}

function handleOptionSingleSelect(state, action) {
  return {
    ...state,
    isMenuOpened: false,
    inputValue: '',
    currentOptions: state.options,
    selectedOption: [action.selectedOption],
    currentAction: '',
  }
}

function handleOptionMultiSelect(state, action) {
  const newSelectedOptions = state.selectedOption.concat(action.selectedOption)
  const newCurrentOptions = state.options.filter((item) => findIndex(newSelectedOptions, { label: item.label }) === -1)

  return {
    ...state,
    inputValue: '',
    currentOptions: newCurrentOptions,
    selectedOption: newSelectedOptions,
    currentAction: '',
  }
}

function handleAllClear(state) {
  return {
    ...state,
    isMenuOpened: false,
    inputValue: '',
    currentOptions: state.options,
    selectedOption: [],
    currentAction: '',
  }
}

function handleMultiRemove(state, action) {
  const selectedIndex = findIndex(state.selectedOption, { label: action.selectedOption.label })

  const cloneSelectedOption = cloneDeep(state.selectedOption)

  const newSelectedOption = [
    ...cloneSelectedOption.slice(0, selectedIndex),
    ...cloneSelectedOption.slice(selectedIndex + 1, cloneSelectedOption.length),
  ]

  const newCurrentOptions = state.options.filter((item) => findIndex(newSelectedOption, { label: item.label }) === -1)

  return {
    ...state,
    currentOptions: newCurrentOptions,
    selectedOption: newSelectedOption,
    currentAction: ACTION.MULTI_REMOVE,
  }
}
